import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const PatientAuthContext = createContext(null);
export const usePatientAuth = () => useContext(PatientAuthContext);

export function PatientAuthProvider({ children }) {
  const [patient, setPatient] = useState(null); // null=checking, obj=authed, false=anon

  const loadMe = useCallback(async () => {
    try { const { data } = await api.get("/portal/me"); setPatient(data); return data; }
    catch { setPatient(false); return false; }
  }, []);
  useEffect(() => { loadMe(); }, [loadMe]);

  const login = async (email, password) => {
    await api.post("/portal/auth/login", { email, password });
    return await loadMe();
  };
  const logout = async () => { try { await api.post("/portal/auth/logout"); } catch { /* ignore */ } setPatient(false); };

  return <PatientAuthContext.Provider value={{ patient, login, logout, loadMe }}>{children}</PatientAuthContext.Provider>;
}
